/**
 * Fire optional webhook when a flow completes (metadata.interviewFlow.webhookOnComplete).
 */
import { resolveStructuredPath } from '../components/studio/studioV2AppBindingMapper';

function setNestedPath(target, dottedPath, value) {
  const parts = String(dottedPath || '').split('.').filter(Boolean);
  if (!parts.length) return;
  let cur = target;
  parts.forEach((part, idx) => {
    if (idx === parts.length - 1) {
      cur[part] = value;
      return;
    }
    if (!cur[part] || typeof cur[part] !== 'object') cur[part] = {};
    cur = cur[part];
  });
}

export async function fireWebhookOnComplete(config, output) {
  const wh = config?.metadata?.interviewFlow?.webhookOnComplete;
  if (!wh?.url || !output || typeof output !== 'object') return { ok: false, skipped: true };

  let body = output;
  if (Array.isArray(wh.includePaths) && wh.includePaths.length) {
    body = {};
    wh.includePaths.forEach((path) => {
      const val = resolveStructuredPath(output, path);
      if (val !== undefined) setNestedPath(body, path.replace(/^result\./, ''), val);
    });
  }

  const headers = {
    'Content-Type': 'application/json',
    ...(wh.headers && typeof wh.headers === 'object' ? wh.headers : {}),
  };
  if (wh.secret && !headers['X-InterviewFlow-Secret']) {
    headers['X-InterviewFlow-Secret'] = String(wh.secret);
  }

  try {
    const res = await fetch(wh.url, {
      method: wh.method || 'POST',
      headers,
      body: JSON.stringify({
        event: 'flow_complete',
        exportedAt: new Date().toISOString(),
        payload: body,
      }),
      mode: 'cors',
    });
    return { ok: res.ok, status: res.status };
  } catch (err) {
    console.warn('[interviewFlow] webhookOnComplete failed:', err?.message || err);
    return { ok: false, error: err?.message || String(err) };
  }
}
